import { DatePipe, formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild, ViewRef,LOCALE_ID } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { of,
Observable,
	BehaviorSubject,
    Subject,	 } from 'rxjs'
import { BaseDialogComponent } from '../../../../base/dialog-base/dialog-base.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, FormulaireService, StateService } from '../../../../services'
import { AtylService } from '../../../service/atyl.service'
import { ConfirmComponent } from '../../../../views/partials/layout/dialogs/confirm-dialog/confirm.component'
import * as moment from 'moment'
import { DateAdapter  , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { ActivatedRoute, Router } from "@angular/router"
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'

import { FormDialogErrorsComponent } from '../form-dialog-errors/form-dialog-errors.component'
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors,Validators,FormControl } from '@angular/forms'
import { debounceTime } from 'rxjs/operators'

const KEY = 'form-dialog-formulaire-with-sf'

@Stringable({
	path: 'motor-form-atyl/form-atyl-components/form-atyl',
	key: KEY
})

@Component({
	selector: 'form-dialog-formulaire-with-sf',
	styleUrls: ['./form-dialog-formulaire-with-sf.component.css'],
	templateUrl: 'form-dialog-formulaire-with-sf.component.html',
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class FormDialogFormulaireWithSFComponent extends BaseDialogComponent implements OnInit {
	@ViewChild('container', { static: false }) container: any
	demandeForm: any
	dateForm: any
	dateFormDebut: any
	dateFormFin: any
	loading: boolean = true;
	loadingPrint: boolean = false;

	listUnderForms: any[] = [];
	underFormIndex: number=0;
	extraUnderForms: any[] = [];
	atylComponents: any
	atylDocuments: string
	atylTemplate: string
	atylDemand: any
	atylDossier: any
	actionForm: string

	currentForm: any
	currentParentForm: any
	nextState: string = '';
	statusForm: string = '1';
	avisForm: string = '0';
	noexit: boolean = false;
	indexForm: any = 0;
	hasPrevButton: boolean = false;
	hasNextButton: boolean = false;
	isEditable: boolean = true;
	isEditableOrginal: boolean = true;
		
	@Output() submited = new EventEmitter<any>();
	drawerLeftIsOpen: boolean = false;
	drawerRightIsOpen: boolean = false;
	customBehaviour: any;
	intervention: any;
	
	visite:any;
	
	currentSection: any;
	sectionEvent:EventEmitter<any> = new EventEmitter<any>();
	scrollTop:number=0;
	
	user:any;
	
	toLoadConsultion:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	
	formLoaded:boolean=false;
	formData:any;
	formChanged:boolean=false;
	formValid:boolean=false;
	
	listContacts: any = [];
	
	isLoadedFoyer:boolean=false;
	isLoadedDocument:boolean=false;
	isLoadedVisite:boolean=false;
	isLoadedLeftSlider:boolean=false;
	
	isNoCreateWithDossier:boolean=false;
	
	codeDroitConfirm = "FORM_CONFIRM";
    droitSkipConfirm:boolean = false;
    
    loadFirst:boolean=false;
    countForm:number=0;

    labels: string[] = ['Formulaire', 'Synthèse', 'Courbes','Courriers'];
    selectIndex: number = 0;
    eventsLoadingSyntheseSubject: Subject<boolean> = new Subject<boolean>();
    eventsLoadingCourbeSubject: Subject<boolean> = new Subject<boolean>();
	eventsLoadingCourrierSubject: Subject<boolean> = new Subject<boolean>();
	eventsRelationsSubject: Subject<boolean> = new Subject<boolean>();
	
    loadedDocument:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	
	validEvent:EventEmitter<any> = new EventEmitter<any>();
	showErrorEvent:EventEmitter<any> = new EventEmitter<any>();
	@StringableValues(KEY) strings: any
	
	isClickBtn:boolean=false;
	
	
	loadedForm:EventEmitter<boolean> = new EventEmitter<boolean>(false);

	ageDebutForm:String = "";
	
	eventReady:any={};
	//clickPrevNextSubject: Subject<string> = new Subject<string>();
	indexFormTemp: number = null;
	
	locked:Boolean=false;
	whoLocked:any={};
		
	ia:any;
	toLoadIA:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
		
	constructor(
		public dialogRef: MatDialogRef<FormDialogFormulaireWithSFComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private atylService: AtylService,
		changeDetectorRef: ChangeDetectorRef,
		private datePipe: DatePipe,
		private snackbar: MatSnackBar,
		private formulaireService: FormulaireService,
		private stateService: StateService,
		dialogService: DialogService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		/*this.clickPrevNextSubject.pipe(debounceTime(300)).subscribe(action => {
			this.goForm(action,this.indexFormTemp);
			this.indexFormTemp = null;
		});
*/
		this.dateFormDebut=new Date();
		this.dateFormFin=new Date();
		if (this.data && this.data.date_debut!=undefined) {
			let begin = moment.parseZone(this.data.date_debut);
			if (begin instanceof moment)
				this.dateFormDebut=begin.toDate();
		}
		if (this.data && this.data.date_fin!=undefined) {
			let end = moment.parseZone(this.data.date_fin);
			if (end instanceof moment)
				this.dateFormFin=end.toDate();
		}
		console.log("FormDialogFormulaireWithSFComponent",this.data,this.dateFormDebut,this.dateFormFin)		
		
		this.stateService.user.subscribe((user) => {
			if (user) {
				this.user = user
                console.log("user dossier",this.user)
				this.setUserSkipConfirm(user.droits)
            }
			
        })
		this.stateService.ia.subscribe((ia) => {
							if (ia) {
								this.ia=ia;

			}
		})
		
		this.atylComponents = ''
		this.atylTemplate = ''
		this.atylDocuments = ''
		this.atylDemand = ''
		if (this.data && this.data.noexit) {
			this.noexit = true
		}
		if (this.data && this.data.isEditable !== undefined)
			this.isEditable = this.data.isEditable
		this.isEditableOrginal=this.isEditable;
        console.log("FormDialogFormulaireWithSFComponent ediatable",this.data,this.isEditable,this.isEditableOrginal)
        if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
        }
        
        if (this.data != undefined && this.data.visite != undefined  && this.data.visite) {
            this.visite = this.data.visite
        }
        
        this.isNoCreateWithDossier=(this.data != undefined 
        && this.data.noCreateWithDossier!=undefined
        && this.data.noCreateWithDossier
        );
        
		if ((this.atylDossier == undefined || !this.atylDossier) && this.data.dossier != undefined && this.data.dossier) {
			this.atylDossier = this.data.dossier
			if (this.data.dossier.tiers)
				this.listContacts = this._getContact(this.data.dossier.tiers.contacts,
					this.data.dossier.tiers.contactsLabel,
					this.data.dossier.tiers.contactsType)
            
		}
		if (!this.data.working) {
			if (!this.loadFirst)
				this.countForm=0;
			if (!this.data.create) {
				console.log(this.data.id, this.data.formType)
				this.subscriptions.push(
					this.atylService.getFormulaireByID(this.data.id, this.data.formType,this.atylDossier).subscribe((res: JSONRpcResponse) => {
						if (res.error) {
														  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
														  let snackBarRef = this.snackbar.open(message,'', {
													                duration: 5000
													              });
																     
														 this.dialogRef.close();
																					  
						} else {
						this.demandeForm = res.result
						this.currentParentForm =res.result
						this.currentForm = this.demandeForm.form
						this.dateForm = this.datePipe.transform(this.demandeForm.creationdate)
						
						this.dateFormDebut = (this.demandeForm.date_debut) ? new Date( this.demandeForm.date_debut) : new Date();
						this.dateFormFin = (this.demandeForm.date_fin) ? new Date( this.demandeForm.date_fin) : null;	
						this.ageDebutForm = this.setAgeDebutForm();
						console.log("FormDialogFormulaireWithSFComponent ngOnInit",this.demandeForm,this.dateFormDebut)
						if (!this.loadFirst && this.demandeForm.stats!=undefined ) {
							this.loadFirst=true;
							this.countForm=this.demandeForm.stats;
							console.log('form id count',this.countForm,this.demandeForm);
						}
						
						console.log("FormDialogFormulaireWithSFComponent demande",this.demandeForm)
						if (this.demandeForm.verrouille!=undefined)
							this.locked=this.demandeForm.verrouille;
						if (this.demandeForm.verrouilleur!=undefined)
							this.whoLocked=this.demandeForm.verrouilleur;
												
						
						
						if (res.result && res.result.childs) {
							res.result.childs.forEach((child) => {
								res.result.form.under_form.forEach((form, index) => {
									if (child.form.key === form.key) {
										res.result.form.under_form[index].demande = child
										res.result.form.under_form[index].child = true
										res.result.form.under_form[index].status = child.status
									}
								})
							})
						}
						
						this.setUnderForms(res.result.form.under_form)
						if (res.result && res.result.form && res.result.form.fields.length > 0 && res.result.form.template) {
							res.result.form.parent = true
							res.result.form.status = res.result.status
							this.listUnderForms.unshift(res.result.form)
						}
						if (res.result && res.result.form && res.result.form.fields) {
							this.currentForm = res.result.form
							this.atylComponents = JSON.stringify(res.result.form.fields)
							this.atylTemplate = res.result.form.template
							this.atylDocuments = JSON.stringify(res.result.documents)
							this.atylDemand = res.result
							this.actionForm = 'formulaire:set'
						}
						if (this.listUnderForms && this.listUnderForms.length > 0) {
							this.hasPrevButton = true
							this.hasNextButton = true
							if (this.indexForm === 0)
								this.hasPrevButton = false
							if (this.listUnderForms.length === this.indexForm)
								this.hasNextButton = false
 console.log("FormDialogFormulaireWithSFComponent mulitple",this.listUnderForms[this.indexForm],this.currentForm);
 							 if (this.listUnderForms[this.indexForm].ID!=this.currentForm.ID)						
								this.changeForm(this.listUnderForms[this.indexForm], this.indexForm)
							else
								this.loading = false
						}
						else
							this.loading = false
						}
					})
				)
				this.changeDetectorRef.detectChanges()
			}
			else {

				let tiersId = null
				if (this.data.tiersId != undefined) {
					tiersId = this.data.tiersId ? this.data.tiersId : (this.data.dossier ? this.data.dossier.tiers.ID : null)
				}
                if (tiersId ==null && this.data.dossier != undefined
                && this.data.dossier.tiers!=undefined
                ) {
                    tiersId=this.data.dossier.tiers.ID;
                }
				let _options = {
					tiersId: tiersId,
					parent: 0
				}
				console.log('new form', this.data.idAForm, _options)
				this.subscriptions.push(
					this.formulaireService.new(this.data.idAForm, _options)
						.subscribe((res: JSONRpcResponse) => {
							this.demandeForm = res.result
							this.currentParentForm =res.result
							this.dateForm = this.datePipe.transform(this.demandeForm.creationdate)
							this.currentForm = res.result.form
							this.data.title = res.result.form.libelle
							
							this.dateFormDebut =  new Date();
						    this.dateFormFin =  null;
							
							if (this.data && this.data.date_debut!=undefined) {
										let begin = moment.parseZone(this.data.date_debut);
										if (begin instanceof moment)
											this.dateFormDebut=begin.toDate();
									}
							if (this.data && this.data.date_fin!=undefined) {
								let end = moment.parseZone(this.data.date_fin);
								if (end instanceof moment)
									this.dateFormFin=end.toDate();
							}
							
							this.ageDebutForm = this.setAgeDebutForm();
							if (!this.loadFirst && this.demandeForm.stats!=undefined ) {
								this.loadFirst=true;
								this.countForm=this.demandeForm.stats;
								console.log('new form count',this.countForm,this.demandeForm);
							}
							
							if (res.result && res.result.childs) {
								res.result.childs.forEach((child) => {
									res.result.form.under_form.forEach((form, index) => {
										if (child.form.key === form.key) {
											res.result.form.under_form[index].demande = child
											res.result.form.under_form[index].child = true
											res.result.form.under_form[index].status = child.status
										}
									})
								})
							}
							this.setUnderForms(res.result.form.under_form)
							if (res.result && res.result.form && res.result.form.fields.length > 0 && res.result && res.result.form.template) {
								res.result.form.parent = true
								res.result.form.status = res.result.status
								this.listUnderForms.unshift(res.result.form)
							}
							if (res.result && res.result.form && res.result.form.fields) {

								this.currentForm = res.result.form
								this.atylComponents = JSON.stringify(res.result.form.fields)
								this.atylTemplate = res.result.form.template
								this.atylDocuments = JSON.stringify(res.result.documents)
								this.atylDemand = res.result
								this.actionForm = 'formulaire:set'
							}


							if (this.listUnderForms && this.listUnderForms.length > 0) {
								this.hasPrevButton = true
								this.hasNextButton = true
								if (this.indexForm === 0)
									this.hasPrevButton = false
								if (this.listUnderForms.length === this.indexForm)
									this.hasNextButton = false
console.log("FormDialogFormulaireWithSFComponent mulitple",this.listUnderForms[this.indexForm],this.currentForm);		
                               if (this.listUnderForms[this.indexForm].ID!=this.currentForm.ID)						
									this.changeForm(this.listUnderForms[this.indexForm], this.indexForm)
							}
							this.loading = false
							this.changeDetectorRef.detectChanges()
						})
				)
			}
		}
	}
	
	ngAfterViewInit() {
        
        this.sectionEvent.subscribe((section:any)=>{
             
              if (section!=undefined 
              && section.id!=undefined) {
                
                  let btnOpen=document.getElementById("btn_section_open");
                let btnOpenelement:HTMLElement = btnOpen as HTMLElement;
                 btnOpenelement.addEventListener("click",this.onClick.bind(this,section),true);
                
                 btnOpenelement.click();
                
                btnOpenelement.removeEventListener("click",()=>{},true); 
                
                
                
                
             }
          
          })
          
          
       
        
        
    }
	onClick(event:any,section:any) {
       /*let btnOpen=document.getElementById("btn_section_open");
       let btnOpenelement:HTMLElement = btnOpen as HTMLElement;
       btnOpenelement.removeEventListener("click",()=>{},true);  
       */
         setTimeout(() => {
                       if (this.currentSection) {
                           let anchor=this.currentSection.id;       
                            let btnId='btn_section_'+ anchor
                            let btn=document.getElementById(btnId);
                            let btnelement:HTMLElement = btn as HTMLElement;
                            console.log("curentSection btn befor event",btnId,btn,btnelement);
                            if (btnelement) {
                                console.log("curentSection btn event",btnelement);
                                btnelement.click();
                            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                                this.changeDetectorRef.detectChanges()
                      }
                        }  
                        this.currentSection=null;  
                 
                    
                    }
                       
         })
         
       
    }
	setUnderForms(under_form: any) {
		this.listUnderForms=[];
		if (under_form.length > 0) {
			this.listUnderForms = []
			this.extraUnderForms = []
			under_form.forEach((form: any) => {
				this.listUnderForms.push(form)
			})
			this.underFormIndex=0;
			
		}
		setTimeout(() => {
			if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
				this.changeDetectorRef.detectChanges()
			}
		})
	}
	ngAfterContentChecked() {
		this.changeDetectorRef.detectChanges()
	}

    onChangeScrolled(elt:any) {
   
            
             
            
             let elt2=document.getElementById(elt.element.id);
             let element:HTMLElement = elt2 as HTMLElement;
             elt.scroll.nativeElement.scrollTop=element.offsetTop;
             this.scrollTop=element.offsetTop;
              console.log("scrolled event",elt,element,element.offsetTop,elt.scroll.nativeElement.scrollTop);
             //this.myScrollContainer.nativeElement.scrollTop=(elt.size) ? elt.size:  element.offsetTop;
             this.changeDetectorRef.detectChanges()
             
         
     } 
       
    getScrollTop() {
        return this.currentSection;
    }
    
	changeForm(form: any, index?: any,section?: any) {
		this.indexForm = index
		this.atylComponents = ''
		this.atylTemplate = ''
		
		this.currentSection=section;
		console.log("changeForm", form, this.currentParentForm,this.currentSection)
		if (this.listUnderForms.length > 0) {
			this.hasPrevButton = true
			this.hasNextButton = true
			if (this.indexForm === 0)
				this.hasPrevButton = false
			if (this.listUnderForms.length === this.indexForm + 1)
				this.hasNextButton = false
		}
		if (form.parent && this.demandeForm.ID) {
			console.log("getFormulaireByID parent", this.demandeForm.ID)
			this.subscriptions.push(
				this.atylService.getFormulaireByID(this.demandeForm.ID, form.key,this.atylDossier).subscribe((res: JSONRpcResponse) => {
					if (res.error) {
													  let message:string=(res.error.data!=undefined) ? res.error.data :res.error.message;
													  let snackBarRef = this.snackbar.open(message,'', {
												                duration: 5000
												              });
															     
													 this.dialogRef.close();
																				  
					} else {
						this.loading = false;
						this.demandeForm = res.result
						this.atylComponents = JSON.stringify(res.result.form.fields)
						this.atylTemplate = res.result.form.template
						this.atylDocuments = JSON.stringify(res.result.documents)
						this.atylDemand = res.result
														
						
						this.currentForm = res.result.form
						this.actionForm = "formulaire:set"
						if (res.result.status != undefined)
							this.statusForm = String(res.result.status)
						if (res.result.favorable != undefined)
							this.avisForm = String(res.result.favorable)
						//this.sectionEvent.next(this.currentSection);
						
							
						this.changeDetectorRef.detectChanges()
						this.loadedForm.next(true);
					}
				})
			)
		}
		else {
			if (form.child) {
				console.log("getFormulaireByID child", this.demandeForm.ID)
				this.subscriptions.push(
					this.atylService.getFormulaireByID(form.demande.ID, form.key,this.atylDossier).subscribe((res: JSONRpcResponse) => {
						if (res.error) {
								  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
								  let snackBarRef = this.snackbar.open(message,'', {
							                duration: 5000
							              });
										     
								 this.dialogRef.close();
															  
						} else {
						this.loading = false;
						this.demandeForm = res.result
						this.atylComponents = JSON.stringify(res.result.form.fields)
						this.atylTemplate = res.result.form.template
						this.atylDocuments = JSON.stringify(res.result.documents)
						this.atylDemand = res.result
						this.currentForm = res.result.form
						this.actionForm = "formulaire:set"
						if (res.result.status != undefined)
							this.statusForm = String(res.result.status)
						if (res.result.favorable != undefined)
							this.avisForm = String(res.result.favorable)
						//this.sectionEvent.next(this.currentSection);
						
						this.changeDetectorRef.detectChanges()
						this.loadedForm.next(true);	
						console.log("etFormulaireByID child res", this.atylComponents, this.atylTemplate)
						}
					})
				)
			}
			else {
				if (this.data.v3) {
					let tiersId = null
					if (this.data.tiersId != undefined) {
						tiersId = this.data.tiersId ? this.data.tiersId : (this.data.dossier ? this.data.dossier.tiers.ID : null)
					}

					if (tiersId ==null && this.data.dossier != undefined
					&& this.data.dossier.tiers!=undefined
					) {
						tiersId=this.data.dossier.tiers.ID;
					}
					let _options = {
						tiersId: tiersId,
						parent: 0

					}
					if (this.currentParentForm != undefined && this.currentParentForm.key != undefined)
						_options["parentForm"] = this.currentParentForm
					console.log("new form 0", form.ID_options, this.currentParentForm)
					this.subscriptions.push(
						this.atylService.v3getFormulaire(form.ID, _options).subscribe((res: JSONRpcResponse) => {
							this.loading = false;
							this.demandeForm = res.result
							this.atylComponents = JSON.stringify(res.result.form.fields)
							this.atylTemplate = res.result.form.template
							this.atylDocuments = JSON.stringify(res.result.documents)
							this.atylDemand = res.result
							this.currentForm = res.result.form
							this.actionForm = "formulaire:set"
							if (res.result.status != undefined)
								this.statusForm = String(res.result.status)
							if (res.result.favorable != undefined)
								this.avisForm = String(res.result.favorable)
							//this.sectionEvent.next(this.currentSection);
						
							this.changeDetectorRef.detectChanges()
							this.loadedForm.next(true);		
							//console.log("new form 0 res", this.atylComponents, this.atylTemplate)
						})
					)
				} else {
					console.log("new form 1", form.ID, this.currentParentForm)
					let parentFormKey = null
					if (this.data.idAForm != undefined)
						parentFormKey = this.data.idAForm
					this.subscriptions.push(this.atylService.getFormulaire(form.ID, this.data.id ? this.data.id : null, (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : "", this.data.tiersId, parentFormKey)).subscribe((res: JSONRpcResponse) => {
						this.demandeForm = res.result
						this.atylComponents = JSON.stringify(res.result.form.fields)
						this.atylTemplate = res.result.form.template
						this.atylDocuments = JSON.stringify(res.result.documents)
						this.atylDemand = res.result
						
						
						this.currentForm = res.result.form
						this.actionForm = "formulaire:set"
						this.loading = false
						if (res.result.status != undefined)
							this.statusForm = String(res.result.status)
						if (res.result.favorable != undefined)
							this.avisForm = String(res.result.favorable)
						//this.sectionEvent.next(this.currentSection);
						
						this.changeDetectorRef.detectChanges()
						this.loadedForm.next(true);		
					}))
				}
			}
		}
	}

	onLoaded(loaded: boolean) {
		this.formLoaded=loaded;
		if (loaded) {
			this.changeDetectorRef.markForCheck()
			this.sectionEvent.next(this.currentSection);
			
		}
	}
	
	onChanged(changed: any) {
		this.formChanged=false;
		this.formValid=false;
		if (this.formData!=changed.data) {
			//if (this.formData)
			   this.formChanged=true;
			this.formData=changed.data;
			this.formValid=changed.valid;
			
			
		}	
		if (changed) {
			
		}
		this.changeDetectorRef.detectChanges();
		console.log("formchanged",this.formChanged,this.formData, this.formLoaded,this.loading);
	}

	getSubmittedEmitter() {
		return this.submited
	}

	onSubmitClone(values: any,issubmited:boolean=true,osf:FormDialogFormulaireWithSFComponent=null,indx:number=0) {
        if (!osf)
			osf=this;
		
		console.log('onSubmit0', values,issubmited,indx)
		for (let key in values) {
			let value = values[key]
			if (/*Array.isArray(value) ||*/ value == '' || value == undefined) {
				values[key] = null
			}
		}

		console.log('onSubmit', values)
		if (issubmited)
			osf.loading = true
		if (!values['close']) {
			osf.data.closeWhenValidate = false
			if (values['next'])
				this.indexForm++
			if (values['prev'])
				this.indexForm--
		}
		else if (values['close'])
			this.data.closeWhenValidate = true
		if (osf.currentForm)
			osf.atylDemand.form = osf.currentForm
			
		let damande_date_debut:string=null;
		if (values['demande_date_debut'] )	 {
			let dtd:string=formatDate(values['demande_date_debut'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
			console.log('damande_date_debut',values['demande_date_debut'], dtd)
		//	damande_date_debut=new Date(dtd);
		 damande_date_debut=dtd
		}
		let damande_date_fin:string=null;
		if (values['demande_date_fin'])	{
			//damande_date_fin=values['demande_date_fin'];
			let dtf:string=formatDate(values['demande_date_fin'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
			 damande_date_fin=dtf
		}
		console.log('damande_date', damande_date_debut,damande_date_fin)
		let same_address:boolean=false;
		for (var i = 0; i < osf.atylDemand.form.fields.length; i++) {
			var field = osf.atylDemand.form.fields[i]
			console.log('field', field)
			if (field.field.type == 'adresse' && field.field.key=="ADRESSE"  && values.hasOwnProperty(field.ID)) {
				var val = values[field.ID];
				if ( 
					val!=undefined
				&& val!=null			
				&& val != ''
				&& val["same_address"]!=undefined
				&& val["same_address"]=='1'
				) 
				same_address=true;		
			}
		}		
		for (var i = 0; i < osf.atylDemand.form.fields.length; i++) {
			var field = osf.atylDemand.form.fields[i]
			
			if (values.hasOwnProperty(field.ID)) {
				var val = values[field.ID]
                console.log('field', field,val)
				if (field.field.type == 'date'  
				&& val!=null
				&& val!=undefined
				&& val != '') {
					var utcDate = formatDate(val, 'yyyy-MM-ddTHH:mm:ss', 'fr-FR')
					if (val instanceof moment) {
						var momentObj = moment(val);
						utcDate=momentObj.utcOffset(0, false).format("YYYY-MM-DDTHH:mm:ss")+"Z"
					}
					
					
					/*
					const regex = /\.000Z$/i;
					var utcDate=val.replace(regex, '');
					*/
					console.log("date submit",field,utcDate,val);
					
					val = utcDate
				}
				
				if (
					
					 field.field.type == 'selectionlist'  
				
				
				) {
					console.log("submit selection list bedore",val)	
					if (val==undefined || val=="" || val==null)
						val=[];
					if (same_address)
						for (var j = 0; j < val.length; j++) {
							if (val[j]["same_address_checked"]!=undefined)
								val[j]["same_address_checked"]="";
							if (val[j]["same_address_value"]!=undefined)
								val[j]["same_address_value"]="";
							if (val[j]["same_address"]!=undefined)
							 	val[j]["same_address"]=val[j]["same_address"].replace('checked="checked"',"");
						}
					console.log("submit selection list",val)	
				}
				if (
					
					 field.field.type == 'checkbox'  
				   && (val==undefined || val=="" || val==null)
				
				) 
				val=[];
				
				field['value'] = val
				osf.atylDemand.form.fields[i] = field
			}
		}
		console.log("submit field",osf.atylDemand.form)
		if (this.currentForm) {
			this.atylDemand.form = {
				form: this.currentForm.ID,
				key: this.currentForm.key
			}
		}
		if (osf.nextState)
			osf.atylDemand.transition = this.nextState
		if (!osf.atylDemand.ID) {
			console.log('if submit', osf.currentForm.ID, osf.data.key, osf.atylDossier,this.intervention,osf.visite)
			let dossierID = (osf.atylDossier != undefined && osf.atylDossier && osf.atylDossier.ID != undefined) ? osf.atylDossier.ID : null
			
			if (dossierID!==null && osf.isNoCreateWithDossier)
				dossierID=null;
			let parentFormKey = null
			if (this.data.idAForm != undefined)
				parentFormKey = this.data.idAForm
			this.subscriptions.push(
				this.atylService.setNewFormulaire(osf.currentForm.ID, osf.currentForm.fields, osf.data.id ? osf.data.id : '', (osf.data.instruction && osf.data.instruction.ID ? osf.data.instruction.ID : ''), osf.currentForm.parent ? '' : osf.data.id, values.etat, values.favorable, dossierID, parentFormKey,osf.intervention,this.visite
				,damande_date_debut,damande_date_fin)
					.subscribe((submitted: JSONRpcResponse) => {
						if (submitted.error) {
					  let message:string=(submitted.error.data!=undefined) ? submitted.error.data : submitted.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 5000
				              });
				     
				       this.dialogRef.close();
									  
						} else {
							
							console.log("onSubmitClone zozo",indx,submitted.result,this.listUnderForms[indx],this.atylDemand.childs);
							if (this.listUnderForms[indx]!=undefined ) {
								this.listUnderForms[indx].demande=submitted.result;
								this.listUnderForms[indx].child = true;
								this.listUnderForms[indx].status = submitted.result.status;
								this.atylDemand.childs[indx]=submitted.result;
								this.changeDetectorRef.detectChanges();
							}
								
							
							/*if (this.atylDemand.childs[indx]!=undefined) {
								this.atylDemand.childs[indx]=submitted.result;
							} else
								this.atylDemand.childs[indx]=submitted.result;
					        if (this.listUnderForms[indx]!=undefined) {
								
								
																			
							}	
							*/
							if (issubmited)
								this.submited.emit(submitted)
							this.snackbar.open('Formulaire enregistré', '', {
								duration: 2500
							})
							if (osf.data && this.data.closeWhenValidate)
								this.dialogRef.close(submitted)
							else {
								if (submitted.result ) {
									osf.data.create=false;
									osf.data.v3=false;
									if( submitted.result.parent!=undefined
									&& submitted.result.parent.ID!=undefined) {
										
										osf.data.id=submitted.result.parent.ID;
										
									} else {
										
										if (
											submitted.result.form!=undefined
											&& submitted.result.form.is_form!=undefined
											&& !submitted.result.form.is_form
											&& submitted.result.ID!=undefined)
												osf.data.id=submitted.result.ID;
										
									}
									
									console.log("onSubmit on submit without close", osf.data);
									if (issubmited)
										this.ngOnInit()
								}
							}
						}	
					}, (err) => {
						console.error(err)
					}, () => {
						if (issubmited)
							this.stateService.formulairesUpdate(true)
					})
			)
		}
		else {
            console.log('esle submit_CLONE', osf.currentForm.ID, osf.data.key, osf.atylDossier,osf.intervention,osf.visite)
			
			this.subscriptions.push(
				this.atylService.setFormulaire(osf.currentForm, osf.data.instruction, osf.demandeForm.ID, values.etat, osf.currentForm.parent ? '' : osf.data.id, values.favorable ? values.favorable : '0',osf.atylDossier,osf.intervention,osf.visite
				,damande_date_debut,damande_date_fin).subscribe((res: JSONRpcResponse) => {
					if (res.error) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 5000
				              });
				     
				       this.dialogRef.close();
									  
					}
					else{
						if (issubmited)
							this.submited.emit(res.result)
						this.snackbar.open('Formulaire enregistré', '', {
							duration: 2500
						})
						if (osf.data && this.data.closeWhenValidate)
							this.dialogRef.close(res.result)
						else {
							if (issubmited)
								this.ngOnInit()
						}
					}		
				}, (err) => {
					console.error(err)
				}, () => {
					if (issubmited)
						this.stateService.formulairesUpdate(true)
				})
			)
		}

	}
	
	onSubmit(values: any,issubmited:boolean=true) {
	        console.log('onSubmit0', values,issubmited)
			for (let key in values) {
				let value = values[key]
				if (/*Array.isArray(value) ||*/ value == '' || value == undefined) {
					values[key] = null
				}
			}

			console.log('onSubmit', values)
			if (issubmited)
				this.loading = true
			if (!values['close']) {
				this.data.closeWhenValidate = false
				if (values['next'])
					this.indexForm++
				if (values['prev'])
					this.indexForm--
			}
			else if (values['close'])
				this.data.closeWhenValidate = true
			if (this.currentForm)
				this.atylDemand.form = this.currentForm
				
			let damande_date_debut:string=null;
			if (values['demande_date_debut'] )	 {
				let dtd:string=formatDate(values['demande_date_debut'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
				console.log('damande_date_debut',values['demande_date_debut'], dtd)
			//	damande_date_debut=new Date(dtd);
			 damande_date_debut=dtd
			}
			let damande_date_fin:string=null;
			if (values['demande_date_fin'])	{
				//damande_date_fin=values['demande_date_fin'];
				let dtf:string=formatDate(values['demande_date_fin'],'yyyy-MM-ddTHH:mm:ss', 'fr-FR');
				 damande_date_fin=dtf
			}
			console.log('damande_date', damande_date_debut,damande_date_fin)
			let same_address:boolean=false;
			for (var i = 0; i < this.atylDemand.form.fields.length; i++) {
				var field = this.atylDemand.form.fields[i]
				console.log('field', field)
				if (field.field.type == 'adresse' && field.field.key=="ADRESSE"  && values.hasOwnProperty(field.ID)) {
					var val = values[field.ID];
					if ( 
						val!=undefined
					&& val!=null			
					&& val != ''
					&& val["same_address"]!=undefined
					&& val["same_address"]=='1'
					) 
					same_address=true;		
				}
			}		
			for (var i = 0; i < this.atylDemand.form.fields.length; i++) {
				var field = this.atylDemand.form.fields[i]
				
				if (values.hasOwnProperty(field.ID)) {
					var val = values[field.ID]
	                console.log('field', field,val)
					if (field.field.type == 'date'  
					&& val!=null
					&& val!=undefined
					&& val != '') {
						var utcDate = formatDate(val, 'yyyy-MM-ddTHH:mm:ss', 'fr-FR')
						if (val instanceof moment) {
							var momentObj = moment(val);
							utcDate=momentObj.utcOffset(0, false).format("YYYY-MM-DDTHH:mm:ss")+"Z"
						}
						
						
						/*
						const regex = /\.000Z$/i;
						var utcDate=val.replace(regex, '');
						*/
						console.log("date submit",field,utcDate,val);
						
						val = utcDate
					}
					
					if (
						
						 field.field.type == 'selectionlist'  
					
					
					) {
						console.log("submit selection list bedore",val)	
						if (val==undefined || val=="" || val==null)
							val=[];
						if (same_address)
							for (var j = 0; j < val.length; j++) {
								if (val[j]["same_address_checked"]!=undefined)
									val[j]["same_address_checked"]="";
								if (val[j]["same_address_value"]!=undefined)
									val[j]["same_address_value"]="";
								if (val[j]["same_address"]!=undefined)
								 	val[j]["same_address"]=val[j]["same_address"].replace('checked="checked"',"");
							}
						console.log("submit selection list",val)	
					}
					if (
						
						 field.field.type == 'checkbox'  
					   && (val==undefined || val=="" || val==null)
					
					) 
					val=[];
					
					field['value'] = val
					this.atylDemand.form.fields[i] = field
				}
			}
			console.log("submit field",this.atylDemand.form)
			if (this.currentForm) {
				this.atylDemand.form = {
					form: this.currentForm.ID,
					key: this.currentForm.key
				}
			}
			if (this.nextState)
				this.atylDemand.transition = this.nextState
			if (!this.atylDemand.ID) {
				console.log('if submit', this.currentForm.ID, this.data.key, this.atylDossier,this.intervention,this.visite)
				let dossierID = (this.atylDossier != undefined && this.atylDossier && this.atylDossier.ID != undefined) ? this.atylDossier.ID : null
				
				if (dossierID!==null && this.isNoCreateWithDossier)
					dossierID=null;
				let parentFormKey = null
				if (this.data.idAForm != undefined)
					parentFormKey = this.data.idAForm
				this.subscriptions.push(
					this.atylService.setNewFormulaire(this.currentForm.ID, this.currentForm.fields, this.data.id ? this.data.id : '', (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''), this.currentForm.parent ? '' : this.data.id, values.etat, values.favorable, dossierID, parentFormKey,this.intervention,this.visite
					,damande_date_debut,damande_date_fin)
						.subscribe((submitted: JSONRpcResponse) => {
							if (submitted.error) {
						  let message:string=(submitted.error.data!=undefined) ? submitted.error.data : submitted.error.message;
						  let snackBarRef = this.snackbar.open(message,'', {
					                duration: 5000
					              });
					     
					       this.dialogRef.close();
										  
							} else {
								if (issubmited)
									this.submited.emit(submitted)
								this.snackbar.open('Formulaire enregistré', '', {
									duration: 2500
								})
								if (this.data && this.data.closeWhenValidate)
									this.dialogRef.close(submitted)
								else {
									if (submitted.result ) {
										this.data.create=false;
										this.data.v3=false;
										if( submitted.result.parent!=undefined
										&& submitted.result.parent.ID!=undefined) {
											
											this.data.id=submitted.result.parent.ID;
											
										} else {
											
											if (
												submitted.result.form!=undefined
												&& submitted.result.form.is_form!=undefined
												&& !submitted.result.form.is_form
												&& submitted.result.ID!=undefined)
													this.data.id=submitted.result.ID;
											
										}
										
										console.log("onSubmit on submit without close", this.data);
										if (issubmited)
											this.ngOnInit()
									}
								}
							}	
						}, (err) => {
							console.error(err)
						}, () => {
							if (issubmited)
								this.stateService.formulairesUpdate(true)
						})
				)
			}
			else {
	            console.log('esle submit', this.currentForm.ID, this.data.key, this.atylDossier,this.intervention,this.visite)
				
				this.subscriptions.push(
					this.atylService.setFormulaire(this.currentForm, this.data.instruction, this.demandeForm.ID, values.etat, this.currentForm.parent ? '' : this.data.id, values.favorable ? values.favorable : '0',this.atylDossier,this.intervention,this.visite
					,damande_date_debut,damande_date_fin).subscribe((res: JSONRpcResponse) => {
						if (res.error) {
						  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
						  let snackBarRef = this.snackbar.open(message,'', {
					                duration: 5000
					              });
					     
					       this.dialogRef.close();
										  
							} else
						{
							if (issubmited)
								this.submited.emit(res.result)
							this.snackbar.open('Formulaire enregistré', '', {
								duration: 2500
							})
							if (this.data && this.data.closeWhenValidate)
								this.dialogRef.close(res.result)
							else  {
								if (issubmited)
									this.ngOnInit()
							}
						}		
					}, (err) => {
						console.error(err)
					}, () => {
						if (issubmited)
							this.stateService.formulairesUpdate(true)
					})
				)
			}

		}
	

	printForm(id: any) {
		this.loading = true

		this.subscriptions.push(
			this.atylService.printFormulaire(id, true, false).subscribe((res: JSONRpcResponse) => {
				this.loading = false
				console.log('printed sf', res)
				if (res.result && res.result.url != undefined)
					window.open(res.result.url)
				else
					of(window.confirm('Pas de donnée disponible'))
			})
		)
	}
	log(event: MouseEvent): void {
		console.log('log', event)
	}
	toggle(pos: string) {
		if (pos == 'left') {
			this.drawerLeftIsOpen = !this.drawerLeftIsOpen
			this.isLoadedLeftSlider=true;
		}
		if (pos == 'right') {
			this.drawerRightIsOpen = !this.drawerRightIsOpen
		}
		this.changeDetectorRef.detectChanges();
	}
	
	goChangeForm(form: any, index?: any,section?: any) {
		console.log("goChangeForm formchanged",form,this.formValid,this.formChanged,this.formData, this.formLoaded,this.loading);
		let dtd:any=Object.assign({}, this.formData);
		dtd["demande_date_debut"] = this.dateFormDebut;
		dtd["demande_date_fin"] = this.dateFormFin;
		let osf:FormDialogFormulaireWithSFComponent=Object.assign({}, this);
		let idx:number=this.underFormIndex;
		if (this.formChanged  && this.isEditable ) {
            if(!this.droitSkipConfirm){
                this.dialogService.open(ConfirmComponent, {
                    data: {
                        libelle: 'Vous avez modifié cet onglet de formulaire.<br/><b>Voulez-vous sauvegarder avant ?</b>'
                    },
                    
                }, (res: any) => {
					if (this.formValid) {
						if (res === 'true') {
										let looded:any= this.loadedForm.subscribe((res:boolean)=> {
											if (res)
												 this.onSubmitClone(dtd,false,osf,idx);
											looded.unsubscribe();
											}
											
											);
											
						}
						
						//this.onSubmit(this.formData);
	                    this.formData=null;
	                    this.formChanged=false;
	                    this.changeForm(form,index,section);
						this.underFormIndex=index;
					 } else
					       this.showErrorEvent.emit(true);
					 			
                });    
            }
			else{
                //this.onSubmit(this.formData);
				if (this.formValid) {
					let looded:any= this.loadedForm.subscribe((res:boolean)=> {
										    if (res)
												this.onSubmitClone(dtd,false,osf,idx);
											looded.unsubscribe();
										}
				    );
					//this.onSubmit(this.formData)
	                this.formData=null;
	                this.formChanged=false;
	                this.changeForm(form,index,section);
					this.underFormIndex=index;
				} else
									       this.showErrorEvent.emit(true);
				//this.onSubmit(dtd,false);
				
            }
		
		} else {
			
			this.formData=null;
			this.formChanged=false;
			this.changeForm(form,index,section);
		}
	}
	
	/** @deprecated */
	goForm(action:string,indexToGo: number) {
		
		console.log("goForm formchanged",this.isEditable,this.formChanged,this.formData, this.formLoaded,this.loading);

		let idx:number=this.underFormIndex;
		/*let inc:number=(action=="next") ? 1 : -1;
		var index:number=this.indexForm+inc;*/
		var index = indexToGo;
		console.log('goForm',index,this.listUnderForms[index]);
		let dtd:any=Object.assign({}, this.formData);
		dtd["demande_date_debut"] = this.dateFormDebut;
		dtd["demande_date_fin"] = this.dateFormFin;
		console.log("___DATES",this.dateFormDebut,this.dateFormFin);
		let osf:FormDialogFormulaireWithSFComponent=Object.assign({}, this);
		if (this.formChanged  && this.isEditable) {
            if(!this.droitSkipConfirm){
                this.dialogService.open(ConfirmComponent, {
                    data: {
                        libelle: 'Vous avez modifié cet onglet de formulaire.<br/><b>Voulez-vous sauvegarder avant ?</b>'
                    },
                    
                }, (res: any) => {
                    /*if (res === 'true') {
                        this.onSubmit(this.formData);
                    } */
					
						
	                    if (this.listUnderForms.length>1
	                    && index>=0 
	                    && index< this.listUnderForms.length)
	                    {
							if (this.formValid) {
													if (res === 'true') {
															let looded:any= this.loadedForm.subscribe((res:boolean)=> {
																if (res)
																	 this.onSubmitClone(dtd,true,osf,idx);
																looded.unsubscribe();
																}
																
																);
							}
							  this.formData=null;
	                        this.formChanged=false;
	                        this.changeForm(this.listUnderForms[index],index);
							this.underFormIndex=index;
	                    }
					} else
						 this.showErrorEvent.emit(true);
                })
            }
            else{
              //this.goChangeForm(this.formData);
			  /* 
				*/
				if (this.listUnderForms.length>1
                    && index>=0 
                    && index< this.listUnderForms.length)
                    {
						let looded:any= this.loadedForm.subscribe((res:boolean)=> {
	   											if (res)
	   											 this.onSubmitClone(dtd,true,osf,idx);
	   											looded.unsubscribe();
	   										}
	   										
						);
						
						
						
						this.formData=null;
                        this.formChanged=false;
                        this.changeForm(this.listUnderForms[index],index);
                    }
            }
			  
		} else {
		
			this.formData=null;
			this.formChanged=false;
		
		
			if (this.listUnderForms.length>1
					&& index>=0 
					&& index< this.listUnderForms.length)
				 {
					this.changeForm(this.listUnderForms[index],index);
				}
		}
		
	}
	
	onTabConsultClick() {
		console.log('FormDialogFormulaireWithSFComponent loadVisite')
		this.isLoadedVisite=true;
	
		this.toLoadConsultion.next(true);
	   this.changeDetectorRef.detectChanges()
	}
	
	goToTierFoyerDossierPage(event: any) {
        console.log("goToTierFoyerDossierPage",event)
      
      	this.dialogService.open(ConfirmComponent, {
                data: {
                    libelle: "Vous allez fermer ce formulaire pour changer de personne ?"
                },
                draggable: true,
            }, (res: any) => {
                if (res && res === 'true') {
                    this.dialogRef.close();
        
				        this.router.navigate([`/home/dossier/${event.type}/${event.dossierID}`], {
				            relativeTo: this.activatedRoute,
				        })
				        
				        /*this.id=event.dossierID;
				        this.reloadDossier()*/
				       // this.selectedTab = 0
				        this.changeDetectorRef.detectChanges()
                }
            })
      
        
    }
    
    private _getContact(contacts: any,contactsLabel: any,contactType:any) {
		let list = []
		Object.keys(contacts).forEach((code) => {
			let tel:boolean=(contactType[code]==2);
			let email:boolean=(contactType[code]==1);
			let mobile:boolean=(contactType[code]==3);
			contacts[code] != null &&
				list.push({ code:code, 
							libelle: contactsLabel[code], 
							value: contacts[code] ,
							type: contactType[code],
							email: email,
							tel: tel,
							mobile: mobile
							})
		})
		return list
	}
	
	loadFoyer() {
		console.log('FormDialogFormulaireWithSFComponent loadFoyer')
		this.isLoadedFoyer=true;
		this.eventsRelationsSubject.next(true)
		this.changeDetectorRef.detectChanges()
	}
	loadDocument() {
		console.log('FormDialogFormulaireWithSFComponent loadDocument')
		this.isLoadedDocument=true;
		this.loadedDocument.next(true);
		this.changeDetectorRef.detectChanges()
	}
	
	loadVisite() {
		
	}

	setUserSkipConfirm(droits){
        let userDroitTemp
        if(droits === Object(droits)){
            userDroitTemp = [droits];
        }
         else{
            userDroitTemp = droits;
        }
        if (userDroitTemp && userDroitTemp.length > 0) {
            userDroitTemp.forEach(droit => {
              if (typeof droit === "object" && droit !== null && droit.hasOwnProperty(this.codeDroitConfirm)) {
                    this.droitSkipConfirm = true;
              }
            });
          }
    }
    
    onValidate(event:any,btn:any,closed:boolean=false) {
		
	
		if (!this.isClickBtn) {
			this.isClickBtn=true;
			let _event={
				validate: true,
				close: closed,
				event: event,
			}
			
				this.validEvent.emit(_event)
		}
		
	}

    changeList(event: any){
        this.selectIndex = event.index;

        if(this.labels[this.selectIndex] == 'Synthèse'){
            this.eventsLoadingSyntheseSubject.next(true);   
        }
        
		if (this.labels[this.selectIndex] === "Courbes") {
			this.eventsLoadingCourbeSubject.next(true)
		}
		if (this.labels[this.selectIndex] === "Courriers") {
					this.eventsLoadingCourrierSubject.next(true)
		}
		
    }
	
	onValidated(event: any) {
		console.log("FormDialogFormulaireWithSFComponent onValidated",event,this.isClickBtn)
		this.isClickBtn=false;
		this.stateService.alertesUpdate(true);
		this.changeDetectorRef.detectChanges();
	}

	onAlertesModif(event: any){
		this.stateService.alertesUpdate(true);
	}

	onDateChange(date: {value: Date,type: String}) {
		console.log('Date change', date);
		if(date.type === "debut"){
			this.dateFormDebut = date.value;
			this.ageDebutForm = this.setAgeDebutForm();
		}
		else if(date.type === "fin")
			this.dateFormFin = date.value;
	}

	setAgeDebutForm(){
		if((this.data.dossier != undefined && this.data.dossier && this.data.dossier.tiers != undefined 
			&& this.data.dossier.tiers && this.data.dossier.tiers.DATENAISSANCE))
		{
			const birthDate = new Date(this.data.dossier.tiers.DATENAISSANCE);
			const givenDate = new Date(this.dateFormDebut);

			let years = givenDate.getFullYear() - birthDate.getFullYear();
			let months = givenDate.getMonth() - birthDate.getMonth();
			let days = givenDate.getDate() - birthDate.getDate();

			if (days < 0) {
				months--;
				const lastDayOfMonth = new Date(givenDate.getFullYear(), givenDate.getMonth(), 0);
				days += lastDayOfMonth.getDate();
			}

			if (months < 0) {
				years--;
				months += 12;
			}
			this.ageDebutForm = this.formatAge(years,months,days);
		}
		return this.ageDebutForm;
	}

	formatAge(year,month,day){
		var formatedAge: string = '';
		if(year > 0){
			formatedAge += year;
			formatedAge += year > 1? " ans": " an";
		}
		if(month > 0){
			if(formatedAge.length>0)
				formatedAge += " "
			formatedAge += month +" mois";
		}
		if(day > 0){
			if(formatedAge.length>0)
				formatedAge += " "
			formatedAge += day;
			formatedAge += day > 1 ? " jours": " jour";
		}
		return formatedAge;
	}
	
	
	 onReadyComponent(event:any) {
			console.log("_onReadyComponent",event)
			
			if (event.ready!=undefined && event.form!=undefined && event.form.ID!=undefined) {
				if (this.eventReady[event.form.ID]==undefined) 
					this.eventReady[event.form.ID]=event.ready
				else
					this.eventReady[event.form.ID]=event.ready
				
				let _isready:boolean=this.isEditableOrginal;
				
				Object.keys(this.eventReady).forEach((ID:any )=> {
					   if (!this.eventReady[ID]) 
							_isready=false;          
				})	
				
				this.isEditable=_isready;
				this.changeDetectorRef.detectChanges()
					
			}
			
			
			
	}

	prevNextClickBtn(action: string) {
		if(this.indexFormTemp == null){
			this.indexFormTemp = this.indexForm;
		}
		this.indexFormTemp = action == 'prev'? this.indexFormTemp -1: this.indexFormTemp +1
		/*this.clickPrevNextSubject.next(action);
		*/
		let elt:any=document.getElementById("menu_item_"+this.indexFormTemp);
		if (elt)
			elt.click();
	}
	
	loadIA() {
		this.toLoadIA.next(true);
	}
}
